import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

import './styles/Header.css';

export default function OnBoardingButton({ selectedTheme, error, state, username, setUsername  }) {

  const sanitizeUsername = (value) => value.replace(/\s+/g, '').toLowerCase();

  const handleUsernameChange = (event) => {
    setUsername(sanitizeUsername(event.target.value));
  };

  const handleUsernameKeyDown = (event) => {
    if (event.key === ' ' || event.code === 'Space' || event.keyCode === 32) {
      event.preventDefault();
    }
  };
  
  return (        
    <>
      <h2 className={`onboarding-theme__h2 ${!selectedTheme ? "not-theme" : ""}`}>Welcome Art Traveler!</h2>
      <div className={`onboarding-theme__username ${!selectedTheme ? "not-theme" : ""}`}>
        <label htmlFor="user_username">Choose a username</label>
        <PublicFormInput 
          className="onboarding-theme__username-input"
          error={error} 
          element="user_username" 
          fillWith={state.user_session.user_username}
          margin
          fullWidth={true}
          fixedPlaceholder='@'
          value={username}
          onChange={handleUsernameChange}
          onKeyDown={handleUsernameKeyDown}
          secondaryColor={true}
        />
        <label className="onboarding-theme__username-helper">Choose a theme color</label>
      </div>
    </>);
}
